const pageTitles = {
    PURCHASE_WIDGET_SDK: "purchase widget sdk",
    PURCHASE_WIDGET_SDK_ERROR: "purchase widget sdk error",
};

export default pageTitles;
